import './styles.scss'
import React from 'react'
import { Row, Col } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

const Index = ({ hotel, selected, selectedRooms, detailed, handleSelectResult, handleSelectRoom, handleShowDetails, ...rest }) => (
  <div className={`hotel-card${selected}${detailed}`} {...rest}>
    <Row className='align-items-center'>
      <Col onClick={handleSelectResult}>
        <Row>
          <Col xs={12}>
            <strong>{hotel.booking.data.name}</strong>
          </Col>
          <Col xs={12}>
            {hotel.booking.data.address}. {hotel.booking.data.postalCode} {hotel.booking.data.city}
          </Col>
          <Col xs={12}>
            <span className='review-score'>{hotel.booking.data.reviewScore}</span>
            <span className='hotel-stars'>
              {[...Array(hotel.booking.data.stars).keys()].map((s) => (
                <i key={s} className='fa fa-star' />
              ))}
            </span>
          </Col>
        </Row>
      </Col>
      <Col xs={3} className='text-center'>
        <strong>
          {`${Math.ceil(hotel.booking.data.priceRange.minPrice)} - ${Math.ceil(hotel.booking.data.priceRange.maxPrice)} ${
            hotel.booking.data.priceRange.currency
          }`}
        </strong>
        <div className='hotel-provider'>
          {I18n.t(`dashboard_providers-${hotel.booking.providerKey ? hotel.booking.providerKey : 'api_' + hotel.provider.toLowerCase()}`)}
        </div>
        <small className='mr-1 show-details' onClick={handleShowDetails}>
          {detailed ? I18n.t('dashboard_hide-details') : I18n.t('dashboard_show-details')}
        </small>
      </Col>
    </Row>
    {detailed && (
      <Row className='mt-2' onClick={handleSelectResult}>
        <Col className='hotel-description'>{hotel.booking.data.description}</Col>
      </Row>
    )}
    <Row className='mt-2'>
      <Col>
        <Row className='hotel-rooms' noGutters>
          {hotel.booking.data.rooms.map((room, index) => {
            return (
              <Col xs={6} key={room.id + index} onClick={() => handleSelectRoom(room.id)}>
                <div className={`hotel-room${selectedRooms.includes(room.id) ? ' selected' : ''}`}>
                  <div className='room-name'>{room.name}</div>
                  {detailed && room.facilities.length > 0 && (
                    <div className='room-facilities'>
                      <strong>{I18n.t('dashboard_facilities')}</strong>
                      {room.facilities.map((f, k) => (
                        <div key={k} className='room-facility'>
                          {f.name}
                        </div>
                      ))}
                    </div>
                  )}
                  <div className='room-rates'>
                    {detailed && <strong>{I18n.t('dashboard_prices')}</strong>}
                    {detailed &&
                      room.rates.length > 0 &&
                      room.rates.map((rate, k) => (
                        <div className='room-rate' key={k}>
                          <div className='info-board'>
                            <span>{rate.board ? rate.board.toLowerCase() + ' - ' : null}</span>
                            <span>
                              {rate.total ? Math.ceil(rate.total) : Math.ceil(rate.price)} {hotel.booking.price.currencyCode}
                            </span>
                            <span className='refundable'> - {I18n.t(rate.refundable ? 'dashboard_refundable' : 'dashboard_non-refundable')}</span>
                          </div>
                          {rate.rateComments && rate.rateComments.length > 0 && rate.rateComments.map((rc, k) => <li key={k}>- {rc}</li>)}
                        </div>
                      ))}
                    {!detailed ? <span className='info-board'>{room.rates.map((rate) => rate.board.toLowerCase()).join(', ')}</span> : null}
                  </div>
                </div>
              </Col>
            )
          })}
        </Row>
      </Col>
    </Row>
  </div>
)

export default Index
